import { render, staticRenderFns } from "./VerticalBarGoals.vue?vue&type=template&id=51e45e63&"
import script from "./VerticalBarGoals.vue?vue&type=script&lang=js&"
export * from "./VerticalBarGoals.vue?vue&type=script&lang=js&"
import style0 from "./VerticalBarGoals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports